import store from '@/store'

// 养殖现状年份数据
export const savePresentTime = async () => {
  const res = await store.dispatch('getPresentTime')
  if (res && res.length) {
    store.commit('setPresentTime', res)
  }
}

export const savePlanningTime = async () => {
  const res = await store.dispatch('getPlanningTime')
  if (res && res.length) {
    store.commit('setPlanningTime', res)
  }
}

export const savePresentInPlanning = async (type = '禁养区', allYear = false, recordId = undefined) => {
  const res = await store.dispatch('getPresentInPlanningTime', {
    type,
    allYear,
    recordId
  })

  if (res && res.length) {
    store.commit('setPresentInPlanningTime', {
      type,
      data: res
    })
  }
}

export const updateTimeList = async (type) => {
  let key = ''
  switch (type) {
    case 'planningTime':
      key = 'setPlanningTime'
      break
    case 'presentTime':
      key = 'setPresentTime'
      break
    case 'setPresentInPlanningTime':
      key = 'setPlanningTime'
      break
  }
  store.commit(key, [])
}
